import { ReactWebComponent } from '@app/utils/web-components'
import type { ProjectLanguage } from '@lokalise/rag'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ProjectProfileIndicatorWrapper = lazy(() =>
  import('./ProjectProfileIndicactorWrapper').then(({ ProjectProfileIndicatorWrapper }) => ({
    default: ProjectProfileIndicatorWrapper,
  })),
)

export class ProjectProfileIndicatorWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['available-langs', 'project-id', 'project-uuid']
  }

  override render() {
    const projectId = this.prop('project-id')
    const projectUuid = this.prop('project-uuid')
    const availableLanguages = this.jsonProp<ProjectLanguage[]>('available-langs') || []

    if (!projectId) {
      return null
    }

    return (
      <AppProviders>
        <ProjectProfileIndicatorWrapper
          projectId={projectId}
          projectUuid={projectUuid}
          projectLanguages={availableLanguages}
        />
      </AppProviders>
    )
  }
}

customElements.define('project-profile-indicator', ProjectProfileIndicatorWebComponent)
